export default "__VITE_ASSET__CJxGiXwV__"